import { render, staticRenderFns } from "./FormPotencia.vue?vue&type=template&id=06753f40"
import script from "./FormPotencia.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormPotencia.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports